import { BitrixVue } from "ui.vue";

BitrixVue.component("ConfigBlockColors", {
	props: ["state"],
	template: `
		<div class="flex config-row__colors">
			<slot></slot>
		</div>
`,
});
